import { gql } from "@apollo/client";

export const GetRoomMany = gql`
  query RoomMany($locationId: String!) {
    roomMany(locationId: $locationId) {
      id
      name
      services {
        id
        imgUrl
        organizationService {
          id
          name
        }
      }
      totalCapacity
      description
    }
  }
`;

export const GetRoomPage = gql`
  query RoomPage($pagination: PaginationInput!, $activeLocationId: String) {
    roomPage(pagination: $pagination, activeLocationId: $activeLocationId) {
      items {
        createdDate
        id
        name
        description
        totalCapacity
        isActive
        location {
          id
          logoUrl
          name
        }
        services {
          id
          organizationService {
            name
          }
        }
      }
      totalRows
    }
  }
`;

export const GetRoomNames = gql`
  query GetRoomNames($locationId: String!) {
    roomMany(locationId: $locationId) {
      id
      name
    }
  }
`;
